module.exports = __webpack_public_path__ + "img/bank.34a662ca.svg";